/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var NoEntryFillIcon = function NoEntryFillIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "cut-out-1ff7697a-834a-4399-9e25-0bf80c94f80e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "10",
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: "7",
    y1: "12",
    x2: "17",
    y2: "12",
    stroke: "black",
    strokeWidth: "2"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "2",
    width: "20",
    height: "20",
    rx: "10",
    mask: "url(#cut-out-1ff7697a-834a-4399-9e25-0bf80c94f80e)"
  }));
};
export default NoEntryFillIcon;